import { OAuthService } from 'angular-oauth2-oidc';
import {
  ConfigStateService,
  CurrentUserDto,
  EnvironmentService,
  ExtensibleObject,
} from '@abp/ng.core';
import { Injectable } from '@angular/core';
import * as signalR from '@microsoft/signalr';
import { Observable, Subscriber } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ImportStatusHubService {
  private _hubConnection: signalR.HubConnection;
  private currentUser$: Observable<CurrentUserDto> = this.configState.getOne$('currentUser');

  constructor(
    environment: EnvironmentService,
    private _authService: OAuthService,
    private configState: ConfigStateService,
  ) {
    this._hubConnection = new signalR.HubConnectionBuilder()
      .withUrl(environment.getApiUrl('default') + '/signalr-hubs/import-status', {
        accessTokenFactory: () => this._authService.getAccessToken(),
      })
      .withAutomaticReconnect()
      .build();
  }

  endConnection(): void {
    if (
      this._hubConnection.state != signalR.HubConnectionState.Disconnected &&
      this._hubConnection.state != signalR.HubConnectionState.Disconnecting
    ) {
      this._hubConnection.stop();
    }
  }

  startConnection(): Observable<void> {
    return new Observable<void>(observer => {
      if (this._authService.getAccessToken()) {
        this.currentUser$.subscribe(response => {
          if (response) {
            this.startHubConnection(observer);
          }
        });
      } else {
        observer.complete();
      }
    });
  }

  private startHubConnection(observer: Subscriber<void>) {
    this._hubConnection
      .start()
      .then(() => {
        this._hubConnection.invoke('SubscribeAsync');
        observer.next();
        observer.complete();
      })
      .catch(error => {
        console.error('Error connecting to SignalR hub:', error);
        observer.error(error);
      });
  }

  receiveImportStatus(): Observable<ImportStatusDto> {
    return new Observable<ImportStatusDto>(observer => {
      this._hubConnection.on('ReceiveImportStatusAsync', (output: ImportStatusDto) => {
        observer.next(output);
      });
    });
  }
}

export interface ImportStatusDto extends ExtensibleObject {
  catalogName: string;
  statusId: string;
  resultFileId: string | null;
}
